import { Entity, Field } from "typegraph";

@Entity({one: "tagSet", many: "tagSets"})
export class TagSet {

	@Field()
	public id: string | number;

	@Field()
	public name: string;

}

export interface ITagSetParams {
	ids?: string;
}



// WEBPACK FOOTER //
// ./src/panels/knowledgebase/entities/TagSet.ts